import lazyLoading from './lazyLoading'

export default {
  name: 'padron',
  meta: {
    expanded: false,
    title: 'Padrón',
    iconClass: 'vuestic-icon vuestic-icon-user'
  },
  children: [
    {
      name: 'padronConfigDrivers',
      path: '/config-drivers',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'menu.drivers'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/DriversList'),
          meta: {
            title: 'menu.drivers'
          }
        },
        {
          path: 'new', // Default route
          component: lazyLoading('config/DriverNew'),
          meta: {
            title: 'Sub Zonas'
          }
        },
        {
          path: ':driverId',
          component: lazyLoading('config/DriverView'),
          props: true,
          meta: {
            title: 'menu.drivers'
          }
        }
      ]
    },
    {
      name: 'padronConfigHolders',
      path: '/config-holders',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Permisionarios'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/HolderList'),
          meta: {
            title: 'Permisionarios'
          }
        },
        {
          path: 'new',
          component: lazyLoading('config/HolderView'),
          props: true,
          meta: {
            title: 'Permisionarios'
          }
        },
        {
          path: ':holderId',
          component: lazyLoading('config/HolderView'),
          props: true,
          meta: {
            title: 'Permisionarios'
          }
        }
      ]
    },
    {
      name: 'padronConfigSupervisors',
      path: '/config-supervisors',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Supervisores'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/SupervisorsList'),
          meta: {
            title: 'Supervisores'
          }
        },
        {
          path: 'new', // Default route
          component: lazyLoading('config/SupervisorNew'),
          meta: {
            title: 'Supervisores'
          }
        },
        {
          path: ':supervisorId',
          component: lazyLoading('config/SupervisorView'),
          props: true,
          meta: {
            title: 'Supervisores'
          }
        }
      ]
    },
    {
      name: 'padronConfigCars',
      path: '/config-cars',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Vehículos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/CarsList'),
          meta: {
            title: 'Vehículos'
          }
        },
        {
          path: ':carId',
          component: lazyLoading('config/CarView'),
          props: true,
          meta: {
            title: 'Vehículo'
          }
        }
      ]
    },
    {
      name: 'padronConfigEmployees',
      path: '/config-employees',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Empleados'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/EmployeesList'),
          meta: {
            title: 'Empleados'
          }
        },
        {
          path: 'new',
          component: lazyLoading('config/EmployeeView'),
          props: true,
          meta: {
            title: 'Empleado'
          }
        },
        {
          path: ':employeeId',
          component: lazyLoading('config/EmployeeView'),
          props: true,
          meta: {
            title: 'Empleados'
          }
        }
      ]
    },
    {
      name: 'padronExpiredDocuments',
      path: '/expired-documents',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Documentos Vencidos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/ExpiredDocumentsList'),
          meta: {
            title: 'Documentos Vencidos'
          }
        }
      ]
    },
    {
      name: 'padronConfigAdminDrivers',
      path: '/config-admin-drivers',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Auto Administrable'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/DriverAdminList'),
          meta: {
            title: 'Auto Administrable'
          }
        },
      ]
    },
    {
      name: 'prints',
      path: '/prints',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Impresiones'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('config/PrintList'),
          meta: {
            title: 'Impresiones'
          }
        }
      ]
    },
    {
      name: 'padronPushDrivers',
      path: '/push-drivers',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Push Conductores'
      },
      children: [
        {
          path: '',
          component: lazyLoading('config/PushDrivers'),
          meta: {
            title: 'Push Conductores'
          }
        }
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/padron.js